import './Profile.scss';
import Mouse from '../../components/Mouse/Mouse';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import FlatTitle from '../LandingPage/components/ContactUs/components/FlatTitle';
import UserProfile from './UserProfile';
import Description from './components/PersonalInfo/components/Description';
import RelatedUsers from './components/PersonalInfo/components/RelatedUsers';
import Footer from '../LandingPage/components/Footer/Footer';

function TrainerProfile() {
  return (
    <>
      <FlatTitle pageName={"Profile"} />
      <UserProfile />
      <Description />
      <RelatedUsers />
      <Mouse />
      <ScrollTop />
      <Footer />
    </>
  );
}

export default TrainerProfile;